import BackButton from "components/Button/BackButton"
import DeleteButton from "components/Button/DeleteButton"
import SaveButton from "components/Button/SaveButton"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { BookingStatusActive, BookingStatusComplete, DateNullDefault, DropdownBookingType, EmptyString, FormTypeAdd, FormTypeEdit, FormTypeView, InsertDateFormat, StatusCodeActive, StatusCodeDelete } from "utils/Constant"
import moment from "moment"
import { GetBookingType, GetMonth, GetPaymentType, money } from "utils/helpers"
import UnDeleteButton from "components/Button/UnDeleteButton"
import DatePicker from "components/Input/DatePicker"
import Dropdown from "components/Input/Dropdown"
import Select from 'react-select'
import CheckCircleIcon from "assets/icon/CheckCircleIcon"
import RevisionIcon from "assets/icon/RevisionIcon"
import PlusIcon from "assets/icon/PlusIcon"
import { BookingService } from "services/BookingService"
import { useModal } from "utils/context/ModalContext"
import { TenantService } from "services/TenantService"
import { PaymentService } from "services/PaymentService"
import { FormCard } from "components/Cards/FormCard"
import { PagesFormTitle } from "components/Cards/PagesFormTitle"
import DataTable from "components/DataTable"
import { MainBodyCard } from "components/Cards/MainBodyCard"

export default function BookingForm(){
    const navigate = useNavigate()

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()

    const { fetchInsertBooking, fetchUpdateBooking, fetchDeleteBooking, fetchBookingById, fetchCompleteBooking, fetchReactiveBooking, fetchAvailableRoomList } = BookingService()
    const { fetchTenantList } = TenantService()
    const { fetchPaymentByBookingId } = PaymentService()

    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let paramBookingId = queryString.get("bookingId")

    // OPTIONS
    const [tenantOptions, setTenantOptions] = useState([])
    const [roomNumberOptions, setRoomNumberOptions] = useState([])
    
    // INPUTS/VALUE
    const [tenant, setTenant] = useState([])
    const [bookingDate, setBookingDate] = useState(new Date())
    const [checkInDate, setCheckInDate] = useState(null)
    const [checkOutDate, setCheckOutDate] = useState(null)
    const [bookingType, setBookingType] = useState(EmptyString)
    const [roomNumber, setRoomNumber] = useState(EmptyString)
    const [bookingStatus, setBookingStatus] = useState(EmptyString)
    const [paymentHistory, setPaymentHistory] = useState([])
    const [remark, setRemark] = useState(EmptyString)
    const [tenantId, setTenantId] = useState(EmptyString)

    const [createDate, setCreateDate] = useState(EmptyString)
    const [status, setStatus] = useState(EmptyString)
    const [updateDate, setUpdateDate] = useState(EmptyString)
    const [updateBy, setUpdateBy] = useState(EmptyString)

    // STATE
    const [showCompleteBtn, setShowCompleteBtn] = useState(false)
    const [showReactiveBtn, setShowReactiveBtn] = useState(false)
    
    // GRID
    const columns = [
        {
            key: "rowNumber",
            header: "No",
            headerClassName: "w-16 font-semibold",
            cellClassName: "text-center"
        },
        {
            key: "paymentDate",
            header: "Payment Date",
            render: (row) => moment(row.paymentDate).format('DD MMM YYYY')
        },
        {
            key: "amount",
            header: "Amount",
            render: (row) => 'Rp ' + money(row.amount)
        },
        {
            key: "paymentPeriode",
            header: "Payment Periode",
            render: (row) => GetMonth(row.paymentPeriodeMonth) + ' ' + row.paymentPeriodeYear
        },
        {
            key: "paymentType",
            header: "Payment Type",
            render: (row) => GetPaymentType(row.paymentType) 
        },
    ]
    
    const bookingDateChange = (e) => { setBookingDate(e) }
    const checkInDateChange = (e) => { 
        
        if (e !== null){
            setCheckInDate(e) 
            getAvailableRoom(e)
        }else{
            setCheckInDate(new Date())
        }
        
    }
    const checkOutDateChange = (e) => { setCheckOutDate(e) }
    const tenantNameChange = (e) => { getTenantList(e) }
    const bookingTypeChange = (e) => { setBookingType(e.value) }
    const roomNumberChange = (e) => { setRoomNumber(e.value) }
    const tenantChange = (e) => { setTenant(e) }
    const remarkChange = (e) => { setRemark(e.target.value) }
    

    const saveBtnClick = async () => {
        if (!validateForm()) return

        const onConfirm = await confirm()
        if (!onConfirm) return

        try {
            showLoading()

            if (formType === FormTypeAdd){
                await fetchInsertBooking(
                    tenant.value,
                    moment(bookingDate).format(InsertDateFormat),
                    moment(checkInDate).format(InsertDateFormat),
                    checkOutDate !== null ? moment(checkOutDate).format(InsertDateFormat) : DateNullDefault,
                    roomNumber,
                    '1',
                    bookingType,
                    remark
                )
            }else{
                await fetchUpdateBooking(
                    paramBookingId,
                    tenant.value,
                    moment(bookingDate).format(InsertDateFormat),
                    moment(checkInDate).format(InsertDateFormat),
                    checkOutDate === null ? DateNullDefault : moment(checkOutDate).format(InsertDateFormat),
                    roomNumber,
                    '1',
                    bookingType,
                    remark
                )
            }
        } finally {
            hideLoading()
            showSuccess({
                onSuccess: () => {
                    navigate('/booking')
                }
            })
        }
    }
    const deleteBtnClick = async () => {
        const onConfirm = await confirm()
        if (!onConfirm) return

        try {
            showLoading()

            await fetchDeleteBooking(paramBookingId, status)
        } finally {
            hideLoading()
            showSuccess({
                onSuccess: () => {
                    navigate('/booking')
                }
            })
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    const completeBtnClick = async () => {
        const onConfirm = await confirm()
        if (!onConfirm) return

        try {
            showLoading()

            await fetchCompleteBooking(paramBookingId, status)
        } finally {
            hideLoading()
            showSuccess({
                onSuccess: () => {
                    navigate('/booking')
                }
            })
        }
    }
    const reactiveBtnClick = async () => {
        const onConfirm = await confirm()
        if (!onConfirm) return

        try {
            showLoading()

            await fetchReactiveBooking(paramBookingId)
        } finally {
            hideLoading()
            showSuccess({
                onSuccess: () => {
                    navigate('/booking')
                }
            })
        }
    }

    const addPaymentClick = (id) => {
        navigate("/payment/form?paymentId=&formType=" + FormTypeAdd + "&bookingId=" + id)
    }
    const tenantClick = (id) => {
        navigate("/tenant/form?tenantId=" + id + "&formType=" + FormTypeView)
    }

    function validateForm(){
        let errorCount = 0

        // if (tenantName === EmptyString){
        //     errorCount++
        //     setErrorTenantName(true)
        // }else{
        //     setErrorTenantName(false)
        // }

        

        if (errorCount > 0){
            return false
        }else{
            return true
        }
    }


    const getBookingById = async () => {
        const res = await fetchBookingById(paramBookingId)
        if (!res) return

        const data = res.data

        setTenant({label: data.tenantName, value: String(data.tenantId)})
        setBookingDate(data.bookingDate)
        setCheckInDate(data.checkInDate)
        setCheckOutDate(data.checkOutDate === DateNullDefault ? null : data.checkOutDate)
        setRoomNumber(String(data.roomNumberId))
        setBookingType(String(data.bookingType))
        setBookingStatus(data.bookingStatus)

        if (data.bookingStatus !== null){
            if (String(data.bookingStatus) === BookingStatusActive){
                setShowCompleteBtn(true)
            } else if (String(data.bookingStatus) === BookingStatusComplete){
                setShowReactiveBtn(true)
            }
        }
        setRemark(data.remark === null ? '' : data.remark)
        setTenantId(data.tenantId)
        setStatus(data.status)
        setCreateDate(data.createDate)
        setUpdateDate(data.updateDate)
        setUpdateBy(data.updateBy)
    }
    const getTenantList = async (tenantName) => {
        const res = await fetchTenantList(
            tenantName,
            EmptyString,
            StatusCodeActive,
            10000,
            0
        )
        if (!res) return

        const data = res.data.listData
        let tempArray = []

        for (let i = 0; i < data.length; i++){
            tempArray.push({ label: data[i].tenantName.toUpperCase(), value: String(data[i].tenantId) })
        }

        setTenantOptions(tempArray)
    }
    const getPaymentByBookingId = async () => {
        const res = await fetchPaymentByBookingId(paramBookingId, 1000, 0)
        if (!res) return

        const data = res.data.listData

        setPaymentHistory(data)
    }
    const getAvailableRoom = async (checkInDate) => {
        const res = await fetchAvailableRoomList(checkInDate)
        if (!res) return

        const data = res.data
        const options = data.map((item) => ({ label: item.roomNumber, value: String(item.roomId) }))

        setRoomNumberOptions(options)
    }

    useEffect(() => {
        const onLoad = async () => {
            try {
                showLoading()

                if (formType === FormTypeEdit || formType === FormTypeView) {
                    await getTenantList('')
                    await getAvailableRoom(new Date())
                    await getBookingById()
                    await getPaymentByBookingId()
                }
                
            } finally {
                hideLoading()
            }
        }

        onLoad()
    }, [])

    return (
        <MainBodyCard>
            <PagesFormTitle
                title='Booking Detail'
                formType={formType}
                status={status}
                createDate={createDate}
                updateBy={updateBy}
                updateDate={updateDate}
            />

            <div className="mt-5 flex flex-col gap-3">
                {(formType === FormTypeEdit || formType === FormTypeView) && (
                    <div className={` ${formType === FormTypeEdit ? 'py-2' : ''} `}>
                        <div className="flex">
                            <div className="flex flex-col sm:flex-row sm:items-center w-full">
                                <div className="w-48">
                                    <span>Booking Status</span>
                                </div>
                                <div className="px-4 hidden sm:block">
                                    <span>:</span>
                                </div>
                                <div className="w-full sm:w-72">
                                    { String(bookingStatus) === BookingStatusActive ? 'Active' : (String(bookingStatus) === BookingStatusComplete ? 'Complete' : '') }
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <FormCard title='Tenant Name'>
                    {formType === FormTypeView ? 
                        <label className="hover:cursor-pointer hover:text-blue-700" onClick={() => { tenantClick(tenantId) }}>{tenant.label}</label>
                        :
                        <Select options={tenantOptions} value={tenant} onInputChange={tenantNameChange} onChange={tenantChange} isDisabled={formType === FormTypeEdit ? true : false} />
                    }
                </FormCard>

                <FormCard title='Booking Date'>
                    {formType === FormTypeView ? 
                        <label>{ moment(bookingDate).format('DD MMMM yyyy') }</label>
                        :
                        <DatePicker className="bg-white h-11 w-full" value={bookingDate} onChange={bookingDateChange} />
                    }
                </FormCard>

                <FormCard title='Check In Date'>
                    {formType === FormTypeView ? 
                        <label>{ moment(checkInDate).format('DD MMMM yyyy') }</label>
                        :
                        <DatePicker className="bg-white h-11 w-full" value={checkInDate} onChange={checkInDateChange} />
                    }
                </FormCard>

                <FormCard title='Check Out Date'>
                    {formType === FormTypeView ? 
                        <label>{ checkOutDate !== null ? moment(checkOutDate).format('DD MMMM yyyy') : '-' }</label>
                        :
                        <DatePicker className="bg-white h-11 w-full" value={checkOutDate} onChange={checkOutDateChange} />
                    }
                </FormCard>

                <FormCard title='Booking Type'>
                    {formType === FormTypeView ? 
                        <label>{ GetBookingType(bookingType) }</label>
                        :
                        <Dropdown options={DropdownBookingType} value={bookingType} onChange={bookingTypeChange} placeholder={"Select Booking Type"} />
                    }
                </FormCard>

                <FormCard title='Room Number'>
                    {formType === FormTypeView ? 
                        <label>{ typeof(roomNumberOptions?.find(x => x.value === roomNumber)) !== 'undefined' ? roomNumberOptions?.find(x => x.value === roomNumber).label : '' }</label>
                        :
                        <Dropdown options={roomNumberOptions} value={roomNumber} onChange={roomNumberChange} placeholder={"Select Room Number"} />
                    }
                </FormCard>

                <FormCard title='Remark'>
                    {formType === FormTypeView ? 
                        <label>{ remark }</label>
                        :
                        <input className="input" value={remark} onChange={remarkChange} />
                    }
                </FormCard>

                {(formType === FormTypeEdit || formType === FormTypeView) && (
                    <div className="mt-4">
                        <span className="font-semibold">Payment History</span>
                        <hr className="mt-2 "/>

                        <DataTable
                            columns={columns}
                            data={paymentHistory ?? []}
                        />

                        <div className="mt-4 flex justify-end">
                            <button className="px-4 py-2 bg-black rounded-md flex items-center justify-center"
                                onClick={() => { addPaymentClick(paramBookingId) }}
                            >
                                <PlusIcon />
                                <span className="text-white">Add Payment</span>
                            </button>
                        </div>
                    </div>
                )}
                
                <div className="mt-5 flex flex-wrap justify-end w-full gap-2">
                    {(formType === FormTypeAdd || formType === FormTypeEdit) && (
                        <SaveButton onClick={saveBtnClick} visible={true} />
                    )}
                    {(formType === FormTypeEdit) && (
                        <DeleteButton onClick={deleteBtnClick} visible={ formType === FormTypeAdd ? false : (status === StatusCodeActive ? true : false) } />
                    )}
                    {(formType === FormTypeEdit) && (
                        <UnDeleteButton onClick={deleteBtnClick} visible={formType === FormTypeEdit ? (status === StatusCodeDelete ? true : false) : false} />
                    )}
                    {showCompleteBtn && (
                        <button className="flex items-center gap-2 bg-black rounded-md px-4 py-2 text-xs" onClick={completeBtnClick}>
                            <CheckCircleIcon className="fill-white w-5" />
                            <span className="text-white">Complete</span>
                        </button>
                    )}
                    {showReactiveBtn && (
                        <button className="flex items-center gap-2 bg-black rounded-md px-4 py-2" onClick={reactiveBtnClick}>
                            <RevisionIcon className="fill-white w-6" />
                            <span className="text-white">Reactive</span>
                        </button>
                    )}
                    <BackButton onClick={backBtnClick}  />
                </div>
            </div>
        </MainBodyCard>
    )
}